import React from 'react'

import './PageLayoutOpening.scss'

const PageLayoutOpening = props => {
  return (
    <div className="PageLayoutOpening">
      { props.text }
    </div>
  )
}

export default PageLayoutOpening
